<template>
    <header id="header-container" class="fullwidth hidden-lg hidden-xl" :class="$router.currentRoute.meta.topClass ? $router.currentRoute.meta.topClass : null">

        <!-- Header -->
        <div id="header">
            <div class="container" style="width: 100%;">
                
                <!-- Left Side Content -->
                <div class="left-side">
                    
                    <div class="left-button hidden-xl" v-if="$router.currentRoute.meta.backButton">
                        <a v-on:click="$root.back()">
                            <i class="las la-arrow-left"></i>
                        </a>
                    </div>

                    <span class="mmenu-trigger" v-if="!$router.currentRoute.meta.backButton">
                        <button class="hamburger hamburger--collapse" type="button">
                            <i class="las la-bars"></i>
                        </button>
                    </span>

                    <div id="logo" v-show="!($router.currentRoute.meta.hideTitle ? $router.currentRoute.meta.hideTitle : false)">
                        <a>
                            {{$router.currentRoute.meta.title}}
                            <i v-if="tooltip" class="las la-info-circle tooltip-top-toggle" v-on:click="tooltipShow = !tooltipShow">
                                <div
                                    class="tooltip-top" 
                                    data-tippy-pos="bottom"
                                    :data-tippy-visible="tooltipShow"
                                    :data-tippy="tooltip ? tooltip : ''">
                                </div>
                            </i>
                        </a>
                    </div>

                </div>


                <div class="right-side">

                </div>
                <!-- Right Side Content / End -->

            </div>
        </div>
        <!-- Header / End -->

    </header>
    <!-- <div class="clearfix"></div>     -->
</template>

<script>
export default {
    name: 'Top',
    props: ['tooltip'],
    data () {
        return {
            tooltipShow: false
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mmenu-trigger i {
        font-size: 38px;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue